// extracted by mini-css-extract-plugin
module.exports = {"creator":"PriceSource_creator__3Qkx4"};